import { render, staticRenderFns } from "./AddWeb.vue?vue&type=template&id=54181486&"
import script from "./AddWeb.vue?vue&type=script&lang=js&"
export * from "./AddWeb.vue?vue&type=script&lang=js&"
import style0 from "./AddWeb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports